module.exports = __webpack_public_path__ + "img/logo.8c8b7a4a.png";